import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFilter1"><Path d="M5.5 3C4.11929 3 3 4.11929 3 5.5V6.76015C3 7.35693 3.21348 7.93402 3.60186 8.38713L8.63889 14.2637C8.87191 14.5355 9 14.8818 9 15.2398V20.523C9 21.5842 10.0718 22.3098 11.0571 21.9157L14.0571 20.7157C14.6266 20.4879 15 19.9363 15 19.323V15.2398C15 14.8818 15.1281 14.5355 15.3611 14.2637L20.3981 8.38713C20.7865 7.93402 21 7.35693 21 6.76015V5.5C21 4.11929 19.8807 3 18.5 3H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter1;
